import * as React from "react";
import getConfig from "next/config";
import { VtoProvider, VirtualMirror } from "@grandvisionhq/fun-products";
import { useVtoWishlist } from "@grandvisionhq/fun-wishlist/shared";
const { publicRuntimeConfig } = getConfig();
const virtualMirrorConfig = publicRuntimeConfig?.virtualMirror || {};
const VirtualMirrorContainer = ({ className }) => {
  const { onToggleWishlist, wishlistedSkuItems } = useVtoWishlist();
  return /* @__PURE__ */ React.createElement(VtoProvider, { config: virtualMirrorConfig }, /* @__PURE__ */ React.createElement(
    VirtualMirror,
    {
      className,
      onToggleWishlist,
      wishlistedSkuItems
    }
  ));
};
export {
  VirtualMirrorContainer as V
};
//# sourceMappingURL=VirtualMirrorContainer.js.map
